import { useMemo } from 'react';
import { connect } from 'react-redux';
import { Button, Box } from '@mui/material';
import { useMaterialReactTable, MaterialReactTable } from 'material-react-table';
import { arraysEqual } from '../../../../utils/collections';
import { tableSelectionOptions, defaultTableOptions } from '../../../util/data-table';
import { locationNameId, locationTypeId, locationColumns } from '../../columns';
import { createContains, deleteContains } from '../../../../redux/actions/buildings';

const ContainsLocation = ({
  loc,
  locationsByName,

  containsCreate,
  containsDelete,
}) => {
  const columns = useMemo(() => locationColumns(), []);
  const data = useMemo(
    // Default order selected first
    () =>
      Object.values(locationsByName)
        .filter((l) => l.name !== loc.name)
        .sort((a, b) => {
          if (a.containedBy === loc.name) {
            if (b.containedBy === loc.name) {
              return a.name.localeCompare(b.name);
            }
            return -1;
          }
          if (b.containedBy === loc.name) return 1;
          return a.name.localeCompare(b.name);
        }),
    [locationsByName, loc]
  );

  const mrt = useMaterialReactTable({
    ...defaultTableOptions,
    ...tableSelectionOptions,
    columns,
    data,
    initialState: {
      columnVisibility: Object.fromEntries(
        columns
          .map((c) => c.id)
          .filter((id) => ![locationNameId, locationTypeId].includes(id))
          .map((id) => [id, false])
      ),
      rowSelection: Object.fromEntries(loc.containsLocations.map((l) => [l, true])),
    },
    getRowId: (l) => l.name,
    renderTopToolbarCustomActions: ({ table }) => {
      const handleApply = () => {
        const selectedNames = table
          .getSelectedRowModel()
          .flatRows.map(({ original }) => original.name);
        function handleRemove() {
          const locationsToRemove = loc.containsLocations.filter((l) => !selectedNames.includes(l));
          if (locationsToRemove.length > 0) return containsDelete(locationsToRemove);
          return Promise.resolve();
        }
        function handleAdd() {
          const locationsToAdd = selectedNames.filter((l) => !loc.containsLocations.includes(l));
          if (locationsToAdd.length > 0) return containsCreate(locationsToAdd);
          return Promise.resolve();
        }
        return handleRemove().then(() => handleAdd());
      };

      return (
        <Box sx={{ display: 'flex', gap: '0.5rem' }}>
          <Button
            color="success"
            disabled={arraysEqual(
              table
                .getSelectedRowModel()
                .flatRows.map(({ original }) => original.name)
                .toSorted(),
              loc.containsLocations
            )}
            onClick={handleApply}
            variant="contained"
          >
            Apply Selection
          </Button>
        </Box>
      );
    },
  });
  return <MaterialReactTable table={mrt} />;
};

function mapStateToProps(state, { building }) {
  return {
    locationsByName: state.entities.buildings.locationsByBuildingIdName[building.id] ?? {},
  };
}

function mapDispatchToProps(dispatch, { loc, building }) {
  return {
    containsCreate: (newContainsLocations) =>
      dispatch(createContains(building.id, loc.name, newContainsLocations, [])),
    containsDelete: (containsLocationsToRemove) =>
      dispatch(deleteContains(building.id, loc.name, containsLocationsToRemove, [])),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ContainsLocation);
